import { render, staticRenderFns } from "./powerNewPut.vue?vue&type=template&id=35bfb306&scoped=true&"
import script from "./powerNewPut.vue?vue&type=script&lang=js&"
export * from "./powerNewPut.vue?vue&type=script&lang=js&"
import style0 from "./powerNewPut.vue?vue&type=style&index=0&id=35bfb306&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bfb306",
  null
  
)

export default component.exports